<template>
    <div v-if="!(modifiedOutline && !modified)" class="space-y-4">
        <div class="flex items-center gap-1 px-1">
            <SvgIcon :icon="command.icon!" class="h-6 w-6 !fill-gray-450" />

            <span class="text-sm text-black">
                {{ command.label }}
            </span>

            <span v-if="isSelection">
                ({{ t('aiDisclosure.forSelectedText') }})
            </span>
        </div>

        <EmbodimentConfigRule
            v-if="configRule"
            v-model="configRule"
            class="bg-grey-20"
            :index="Number(configRule.embodiment_number)"
            :disabled="beforeGenerateLoading"
        />

        <div class="flex items-center justify-end gap-2">
            <button :disabled="beforeGenerateLoading || !validated" class="th-btn th-btn-primary" @click="startGenerate">
                <span v-if="beforeGenerateLoading" class="th-loading th-loading-spinner th-loading-sm mr-1 fill-current" />
                <span>{{ t('aiDisclosureGlobal.globalBtn.generate') }}</span>
            </button>
        </div>
    </div>
    <div v-else>
        <SpiltEditorEdit
            v-bind="props"
            @replace="handleReplace"
            @addition="handleAddition"
            @close="$emit('close')"
        >
            <template v-for="(_, slotName) in $slots" #[slotName]="scopedProps">
                <slot :name="slotName" v-bind="scopedProps || {}" />
            </template>
            <template #prepend="{ generating }">
                <EmbodimentConfigRule
                    v-if="configRule"
                    v-model="configRule"
                    class="bg-grey-20 mt-4"
                    :index="Number(configRule.embodiment_number)"
                    :disabled="generating"
                />
            </template>
        </SpiltEditorEdit>
    </div>
</template>

<script setup lang="ts">
import _ from 'lodash';
import { useEmbodimentImprovement } from './composables/use-embodiment-improvement';
import EmbodimentConfigRule from '../embodiment-section/EmbodimentConfigRule.vue';
import { computed } from 'vue';
import SpiltEditorEdit from '@telecom/shared/components/spilt-editor/components/SpiltEditorEdit.vue';
import SvgIcon from '@telecom/shared/components/SvgIcon.vue';
import { useCommands } from '@telecom/shared/composables/use-commands';
import { useI18n } from 'vue-i18n';

const { commands } = useCommands();
const { t } = useI18n();

const command = computed(() => {
    return _.find(commands.getAllCommands(), { id: props.commandId })!;
});

const emits = defineEmits<{
    (event: 'close'): void;
    (event: 'replace', newText: string): void;
    (event: 'addition', newText: string): void;
}>();

const props = defineProps<{
    floatingStyles: { [key: string]: string };
    isSelection: boolean;
    commandId: string;
    addTypeList: string[];
    placeholder?: string;
}>();

const {
    configRule,
    generate,
    modified,
    beforeGenerateLoading,
    modifiedOutline,
    validated,
    comfirm,
} = useEmbodimentImprovement();

const startGenerate = () => {
    generate();
};

const handleReplace = async (newText: string) => {
    await comfirm();
    emits('replace', newText);
};

const handleAddition = async (newText: string) => {
    await comfirm();
    emits('addition', newText);
};
</script>

<style lang="scss">

</style>
